import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_FSTD_READ_STATISTICS } from 'client/redux/fstd/constants';

export const instanceFstdReadStatistics = (id, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatistics(INSTANCE_FSTD_READ_STATISTICS, id, statistic, query));
  }
};
